// extracted by mini-css-extract-plugin
module.exports = {"line":"Skeleton_line__2Sc-R","loading":"Skeleton_loading__1rhfh","dark":"Skeleton_dark__3ZWdx"};